import requset from "utils/request";
import { SEARCH } from "apiurl/index.js";
export function sortList(params) {
  return requset({
    url: `${SEARCH}/sort`,
    method: "GET",
    params
  });
}
export function sortAll(params) {
  return requset({
    url: `${SEARCH}/all`,
    method: "GET",
    params
  });
}
export function searchAll(params) {
  return requset({
    url: `${SEARCH}/query`,
    method: "GET",
    params
  });
}
export function conditions(params) {
  return requset({
    url: `${SEARCH}/conditions`,
    method: "GET",
    params
  });
}
